import { LoadingService } from 'src/app/_services/loading.service';
import { EmailIntegrationService } from './../../_services/email-integration.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { GlobalService } from 'src/app/_services/global.service';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { EmailsettingsService } from 'src/app/_services/emailsettings.service';
import _ from 'underscore';
import { CandidateService } from 'src/app/_services/candidate.service';
import * as __ from 'lodash';
declare const clevertap;
import { environment } from 'src/environments/environment';
import { SearchtoolboxService } from 'src/app/_services/searchtoolbox.service';

const frontendurl = environment.frontendurl
const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

@Component({
  selector: 'app-intro-candidateemail',
  templateUrl: './intro-candidateemail.component.html',
  styleUrls: ['./intro-candidateemail.component.scss']
})
export class IntroCandidateemailComponent implements OnInit {

  placeholderlist = GlobalService.placeholderlist.filter(x => x.value != 'candidate.currentjobtitle' && x.value != 'candidate.currentcompany' && x.value != 'candidate.currentlocation')
  bulkemail_Form: FormGroup;
  customtempList: any;
  checboxvalue: any;
  range: any;
  sel: Selection;
  InputtoEdit: any;
  isTemplateEdited: boolean = false;
  placeid: boolean;
  incorrectdoc: boolean;
  special_char_error: boolean;
  uploadedFiles: Array<any> = [];
  selectedEmailTemplate: any = null;
  talentvalue: string = null;
  pipeline_list = GlobalService.PipelineStatus;
  candidate_emaillist: any[] = []
  bulkEmails: any[] = []
  username: any = this._localstorageservice.getItem('ufname') + ' ' + this._localstorageservice.getItem('ulname')
  @Input() pipelinestatus: any;
  @Input() candidatenumber: any;
  @Input() candidateLinks: any;
  @Input() candidateName: any;
  @Input() balancesmartemailcredits: any;
  @Input() smartemailcredits: any;
  @Input() SearchToolbox_ExploreConnect_Result: any;
  @Input() SearchToolbox_ExploreConnect_Bulk_Attempt: any;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @ViewChild('subject') subject: ElementRef;
  @ViewChild('successModal') successModal: TemplateRef<any>
  @ViewChild('noPersonalFound') noPersonalFound: TemplateRef<any>
  @ViewChild('noEmailModal') noEmailModal: TemplateRef<any>
  @ViewChild('BulksuccessModal') BulksuccessModal: TemplateRef<any>


  editorConfig: AngularEditorConfig = {

    editable: true,
    spellcheck: true,
    height: '10rem',
    minHeight: '5rem',
    placeholder: 'Please enter job description.',
    translate: 'no',
    uploadUrl: 'v1/images', // if needed
    customClasses: [ // optional
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
    toolbarHiddenButtons: [[
      'fontSize',
      'insertVideo',
      'fontName',
      'heading',
      'customClasses'
    ]
    ]
  };
  talentErrorMessage: string;
  integratedemailsarray: any[] = [];
  useremailid: any;
  selectedItem: any = {};
  selectedPlatform: any = 'default';
  filesizeExceeded: boolean = false;
  candidatedetails: any[];
  candidate_withoutemail: any[];
  errorMessage: string;
  emailPrefrence: any[] = ['Personal Only', 'Professional only', 'Priority personal else professional', 'Priority professional else personal']
  selected_emailpreference : any = 'Personal Only'
  singleCandidateDetails: any;
  apiCompleted: boolean;
  sendEmailForSingleCandidate: boolean;
  singleCandidateNumber: any;
  selectedtempalteid: any;
  constructor(public modalService: NgbModal,
    private fb: FormBuilder, private _localstorageservice: LocalStorageService, private emailsettings: EmailsettingsService,
    public _candidateservice: CandidateService, private emailintegrationservice: EmailIntegrationService,
    private searchtoolbox: SearchtoolboxService, private loader: LoadingService) { }

  ngOnInit() {
    let userdata = this._localstorageservice.getItem('userdata')
    if(userdata.company){
      this.placeholderlist.push({
        value: "user.company", type: 'user' 
      })
    }
    if(userdata.designation){
      this.placeholderlist.push({
        value: "user.designation", type: 'user' 
      })
    }
    window.addEventListener('storage', (event) => {
      if (event.key == 'gmail_integration' || event.key == 'outlook_integration') {
        if (event.newValue == 'success') {
          this.fetchIntegration()
        } else {
          this.errorMessage = event.newValue;
          setTimeout(() => this.errorMessage = '', 5000);
        }
      }
      setTimeout(() => {
        localStorage.removeItem("gmail_integration");
        localStorage.removeItem("outlook_integration");
      }, 2000)
    }, false);

    let todisplayText;
    if(this.candidateName){
      todisplayText = this.candidateName
    }else if(this.candidateLinks){
      this.candidateLinks = _.uniq(this.candidateLinks)
      todisplayText = this.candidateLinks.length + " selected"
    }
    this.bulkemail_Form = this.fb.group({
      from: [null, Validators.required],
      todisplay: [{ value: todisplayText, disabled: true }],
      selectedtemplateid: [null],
      subject: [null, Validators.required],
      emailtemplate: [null, Validators.required],
      fileupload: [],
      filename: [],
      fileurl: [],
      file: [],
    })

    this.bulkemail_Form.controls.emailtemplate.valueChanges.subscribe((res:any)=>{
      let scriptRegex = /&lt;script(.*)&gt;/g;
      let scriptRegex1 = /<script(.*)>/g;
      res = res ? res.replace(/<[^>]*>?/gm, '').toLowerCase() : ''
      if (res && (res.includes('onerror') || res.includes('prompt') || res.includes('src') || scriptRegex.test(res.trim()) == true || scriptRegex1.test(res.trim()) == true || res.includes('src='))) {
        this.bulkemail_Form.patchValue({
          emailtemplate: ""
        }, { emitEvent: false })
        this.bulkemail_Form.get('emailtemplate').setErrors({ 'scriptTagError': true })
      }else{
        this.bulkemail_Form.get('emailtemplate').setErrors(null)
      }
    })
    this.getEmailTemplate()
    this.fetchIntegration()

    // this.getSingleCandidateCSEResult()
  }
  
  testscript() {
    this.bulkemail_Form.controls.emailtemplate.valueChanges.subscribe((res:any)=>{
      let scriptRegex = /&lt;script(.*)&gt;/g;
      let scriptRegex1 = /<script(.*)>/g;
      if(res && (scriptRegex.test(res.trim()) == true || scriptRegex1.test(res.trim()) == true || res.includes('src='))){
        this.bulkemail_Form.get('emailtemplate').setErrors({ 'scriptTagError': true })
      }else{
        this.bulkemail_Form.get('emailtemplate').setErrors(null)
      }
    })
  }
  
  ngOnDestroy() {
    if(this.SearchToolbox_ExploreConnect_Result != undefined){
      this.cleverTapEvent('SearchToolbox_ExploreConnect_Dismiss',this.SearchToolbox_ExploreConnect_Result)
    }
    if(this.SearchToolbox_ExploreConnect_Bulk_Attempt != undefined){
      this.cleverTapEvent('SearchToolbox_ExploreConnect_Bulk_Attempt_Dismiss',this.SearchToolbox_ExploreConnect_Bulk_Attempt)
    }
  }

  getSingleCandidateCSEResult(type?) {
    if(this.bulkemail_Form.valid){
    this.sendEmailForSingleCandidate = type ? true : false
    if (this.candidateLinks && this.candidateLinks.length == 1 && !this.singleCandidateDetails && !type) {
      let data = {
        profileurlsarray: this.candidateLinks
      }
      this.searchtoolbox.enrichcseresults(data).subscribe((res: any) => {
        if (res.data && res.data.length) {
          this.singleCandidateDetails = res.data[0]
          this.singleCandidateNumber = this.singleCandidateDetails.candidatenumber ? this.singleCandidateDetails.candidatenumber : this.singleCandidateDetails.datastore_candidatenumber
          let contactDetails = this.singleCandidateDetails.contact_details
          let moreEmailsCount = (contactDetails.emails) ? (contactDetails.emails.numberOfMoreAvailableDetails) : 0;
          let moreSocialCount = (contactDetails.socialprofiles) ? (contactDetails.socialprofiles.numberOfMoreAvailableDetails) : 0;
          let moreContactNumbersCount = (contactDetails.contactnumbers) ? (contactDetails.contactnumbers.numberOfMoreAvailableDetails) : 0;
          this.singleCandidateDetails.emails = contactDetails.emails ? contactDetails.emails : []
          this.singleCandidateDetails.contactnumbers = contactDetails.contactnumbers ? contactDetails.contactnumbers : []
          this.singleCandidateDetails.socialprofiles = contactDetails.socialprofiles ? contactDetails.socialprofiles : []
          if(this.singleCandidateDetails.socialprofiles && this.singleCandidateDetails.socialprofiles.length){
            this.singleCandidateDetails.socialprofiles = this.singleCandidateDetails.socialprofiles.filter(x => x.platformname != 'linkedin')
          }
          this.singleCandidateDetails.totalcontacts_from_pdl = moreEmailsCount + moreContactNumbersCount + moreSocialCount
          if ((this.singleCandidateDetails.totalcontacts_from_pdl > 0 && this.singleCandidateDetails.candidatenumber) || 
          (!this.singleCandidateDetails.candidatenumber && this.singleCandidateDetails.datastore_candidatenumber) || 
          (this.singleCandidateDetails.candidatenumber && this.singleCandidateDetails.basic_details && this.singleCandidateDetails.basic_details.pdlenrichmentviewed == 0)) {
            let requestOBJ = {
              datastore_candidatenumbers_array: this.singleCandidateDetails.datastore_candidatenumber ? this.singleCandidateDetails.datastore_candidatenumber : [],
              candidatenumbers_array: this.singleCandidateDetails.candidatenumber ? this.singleCandidateDetails.candidatenumber : []
            }
            this._candidateservice.bulkrevealbasiccontacts(requestOBJ).subscribe((res: any) => {
              if (res.status == 'success') {
                this.apiCompleted = true
                this.singleCandidateDetails.candidatenumber = res.data && res.data.length ? res.data[0].candidatenumber : this.singleCandidateDetails.candidatenumber
                this.singleCandidateNumber = this.singleCandidateDetails.candidatenumber ? this.singleCandidateDetails.candidatenumber : this.singleCandidateDetails.datastore_candidatenumber
                this.singleCandidateDetails.datastore_candidatenumber = null
                this.singleCandidateDetails.piplenrichmentlastdoneon = 'datetoday'
                try{
                  if (res.data && res.data.length && res.data[0].contact_details) {
                    let newContacts = res.data[0].contact_details
                    this.singleCandidateDetails.emails = newContacts.emails ? newContacts.emails.newMoreAvailableDetails : []
                    this.singleCandidateDetails.contactnumbers = newContacts.contactnumbers ? newContacts.contactnumbers.newMoreAvailableDetails : []
                    this.singleCandidateDetails.socialprofiles = newContacts.socialprofiles ? newContacts.socialprofiles.moreAvailableDetails : []
                    if(this.singleCandidateDetails.socialprofiles && this.singleCandidateDetails.socialprofiles.length){
                      this.singleCandidateDetails.socialprofiles = this.singleCandidateDetails.socialprofiles.filter(x => x.platformname != 'linkedin')
                    }
                  }
                }catch(e){
                  console.log(e , "error if any")
                }
                this.SendEmailToCandidateModal()
              }
            })
          } else {
            this.apiCompleted = true
            this.SendEmailToCandidateModal()
            // if (this.sendEmailForSingleCandidate) {
            //   this.SendEmailToCandidateModal()
            // }
          }
        }
      })
    }else if (this.candidateLinks.length > 1){
      this.SendEmailToCandidateModal()
    }
  }
  }

  SendEmailToCandidateModal() {
    this.collapseALldiv()
    if (this.bulkemail_Form.valid) {
      if (this.candidateLinks.length == 1) {
        this.loader.startLoading()
        if (this.apiCompleted) {
          if (this.singleCandidateDetails.emails && this.singleCandidateDetails.emails.length) {
            this.singleCandidateDetails.professional_email = this.singleCandidateDetails.emails.filter(x => x.contactdetailcategory == "current_professional").map(x => x.contactdetail)
            this.singleCandidateDetails.personal_email = this.singleCandidateDetails.emails.filter(x => x.contactdetailcategory == "personal").map(x => x.contactdetail)
            if(this.singleCandidateDetails.personal_email && this.singleCandidateDetails.personal_email.length == 0){
              //iCloud , Outlook, Hotmail, gmail, aol
              this.singleCandidateDetails.personal_email = this.singleCandidateDetails.personal_email.filter(x => x.contactdetail && (x.contactdetail.toLowerCase().includes('@icloud') || x.contactdetail.toLowerCase().includes('@outlook') || x.contactdetail.toLowerCase().includes('@hotmail') || x.contactdetail.toLowerCase().includes('@gmail') || x.contactdetail.toLowerCase().includes('@aol')))
            }
          }
          if (this.singleCandidateDetails.personal_email && this.singleCandidateDetails.personal_email.length && this.selected_emailpreference == 'Personal Only') {
            this.sendEmail('single','primary')
          } else if (this.singleCandidateDetails.professional_email && this.singleCandidateDetails.professional_email.length && this.selected_emailpreference == 'Professional only') {
            this.sendEmail('single','professional')
          } else if (
            ((this.singleCandidateDetails.professional_email && this.singleCandidateDetails.professional_email.length) || 
            (this.singleCandidateDetails.personal_email && this.singleCandidateDetails.personal_email.length)) && 
            (this.selected_emailpreference == 'Priority professional else personal' || this.selected_emailpreference == 'Priority personal else professional')) {
            this.sendEmail('single','priority')
          } else {
            this.loader.stopLoading()
            this.modalService.dismissAll()
            this.modalService.open(this.noPersonalFound, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
            let data ={
              mailnotsentcandidatenummbersarray : [this.singleCandidateNumber],
              mailpreference : this.selected_emailpreference
            }
            this.searchtoolbox.storemailsendingactivity(data).subscribe()
          }
        } else {
          //let the console be here for testing
          console.log("Wait for email")
          this.getSingleCandidateCSEResult('sendEmail')
        }
      } else if (this.candidateLinks.length > 1) {
        this.sendEmail('bulk')
      }
    } else {
      this.validateAllFormFields(this.bulkemail_Form);
    }
  }

  sendEmail(type, source?) {
    let formValue = this.bulkemail_Form.getRawValue();
    let selectedEmail;
    if(type == 'single' && this.singleCandidateDetails && (this.singleCandidateDetails.professional_email || this.singleCandidateDetails.personal_email)){
      if(this.selected_emailpreference == 'Priority personal else professional' && this.singleCandidateDetails){
        selectedEmail = this.singleCandidateDetails.personal_email && this.singleCandidateDetails.personal_email.length ? this.singleCandidateDetails.personal_email[0] : this.singleCandidateDetails.professional_email[0]
      }else if(this.selected_emailpreference == 'Priority professional else personal' && this.singleCandidateDetails){
        selectedEmail = this.singleCandidateDetails.professional_email && this.singleCandidateDetails.professional_email.length ? this.singleCandidateDetails.professional_email[0] : this.singleCandidateDetails.personal_email[0]
      }else if (source == 'professional') {
        selectedEmail = this.singleCandidateDetails.professional_email[0]
      }else if(source == 'primary'){
        selectedEmail = this.singleCandidateDetails.personal_email[0]
      }
    }else if(type =='single'){
      this.loader.stopLoading()
      this.modalService.dismissAll()
      this.modalService.open(this.noPersonalFound, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
      let data ={
        mailnotsentcandidatenummbersarray : [this.singleCandidateNumber],
        mailpreference : this.selected_emailpreference
      }
      this.searchtoolbox.storemailsendingactivity(data).subscribe()
    }

    let reqObj: any = {
      "candidateemails": [],
      "from": formValue.from,
      "subject": formValue.subject.replace(/'/g, "''"),
      "template": formValue.emailtemplate.replace(/'/g, "''"),
      "updatedby": this._localstorageservice.getItem('userid'),
      "sendviaexploreconnect" : true
    }
    
    if(selectedEmail){
      reqObj['candidateemails'] = [selectedEmail]
    }
    if (this.integratedemailsarray && this.integratedemailsarray.length) {
      if (this.selectedPlatform == 'outlook' || this.selectedPlatform == 'gmail') {
        reqObj['integratedemailtype'] = this.selectedPlatform
      }
      reqObj['from'] = this.selectedItem['emailid']
    }
    if (formValue.fileurl && formValue.fileurl.length) {
      reqObj.attachments = formValue.fileurl.map((url, index) => {
        return {
          'filename': formValue.filename[index],
          'path': formValue.file[index]
        }
      });
    }
    if (type == 'bulk') {
      reqObj.profileurlsarray = this.candidateLinks
      reqObj.mailpreference = this.selected_emailpreference.toLowerCase()
      delete reqObj.candidateemails
      delete reqObj.updatedby
      delete reqObj.sendviaexploreconnect
      this.searchtoolbox.bulkcandidatereachout(reqObj).subscribe((res: any) => {
        if (res.status == 'success') {
          this.modalService.dismissAll()
          const dialogRef = this.modalService.open(this.BulksuccessModal, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
          // this.passEntry.emit('emailsend')
        } else if (res.status == 'failure' && res.message == 'insufficient credits') {
          this.passEntry.emit('nocredits')
        } else if (res.status == 'failure' && res.message == 'mail limit exceeded') {
          this.passEntry.emit('limitexceeded')
        }
      })
    } else if(reqObj['candidateemails'] && reqObj['candidateemails'].length) {
      this.emailsettings.sendbulkemail(reqObj).subscribe((res: any) => {
        if (res.status == 'success') {
          this.modalService.dismissAll()
          const dialogRef = this.modalService.open(this.successModal, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
          // this.passEntry.emit('emailsend')
        } else if (res.status == 'failure' && res.message == 'insufficient credits') {
          this.passEntry.emit('nocredits')
        } else if (res.status == 'failure' && res.message == 'mail limit exceeded') {
          this.passEntry.emit('limitexceeded')
        }
      })
    }
  }

  collapseALldiv() {
    let elems = document.querySelectorAll(".collapse");
    elems.forEach.call(elems, function (el) {
      el.classList.remove("show");
    });
  }

  fetchIntegration() {
    this.emailintegrationservice.fetchintegratedemails().subscribe((res: any) => {
      if (res.status == 'success') {
        if (res.integratedemailsarray && res.integratedemailsarray.length) {
          this.integratedemailsarray = this.integratedemailsarray
          this.integratedemailsarray = this.integratedemailsarray.concat(res.integratedemailsarray).map((x: any) => {
            let res = x
            if (x && x.integrationplatform == 'outlook') {
              x.icon = '../../../assets/ourtlook.png'
            }
            if (x && x.integrationplatform == 'gmail') {
              x.icon = '../../../assets/gmail.png'
            }
            return res
          })
          if (this.integratedemailsarray && this.integratedemailsarray.length) {
            let value = this.integratedemailsarray.filter(x => { return x.integrationplatform == 'gmail' || x.integrationplatform == 'outlook' })[0].integrationplatform
            this.selectFromEmail(value)
          }
        }
      }
    })
  }

  getEmailTemplate() {
    this.emailsettings.getallEmailTemplate(this._localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == "success") {
        this.customtempList = res.message.filter(x => x.displayforintrofeature == 1 || x.loginfirstname || x.loginlastname)
        let selectedtemplate = res.message.filter(x => x.action == 'personalized cold email reachout')
        if(selectedtemplate && selectedtemplate.length){
          this.selectedtempalteid = selectedtemplate[0].templateid
          let event ={
            target :{
              value : this.selectedtempalteid
            }
          }
          this.selectedTemplateOption(event)
        }
      }
      else {
        console.log("error")
      }
    })
  }

  selectFromEmail(e) {
    this.selectedPlatform = e
    this.selectedItem['icon'] = this.integratedemailsarray.filter(x => x.integrationplatform == e)[0].icon
    this.selectedItem['emailid'] = this.integratedemailsarray.filter(x => x.integrationplatform == e)[0].emailid
    this.bulkemail_Form.patchValue({
      from:  this.selectedItem
    })
  }

  selectedTemplateOption(event: any) {
    this.emailsettings.getEmailDetails(event.target.value,this._localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == "success") {
        this.selectedEmailTemplate = res.message[0];
        this.bulkemail_Form.patchValue({
          subject: this.selectedEmailTemplate.subject,
          emailtemplate: this.selectedEmailTemplate.template
        })
        this.isTemplateEdited = false;
      }
      else {
        console.log("Something went Wrong")
      }
    })
  }

  selectEmailType(event: any) {
    this.selected_emailpreference = event.target.value
  }

  //Placeholder
  selectplaceholder(event: any) {
    this.checboxvalue = event.target.value;
    if (this.range) {
      if (this.InputtoEdit == 'body') {
        var el = document.createElement("div");
        el.innerHTML = ('<span class="nonEdit"> {{' + this.checboxvalue + '}} </span>');
        var frag = document.createDocumentFragment(), node, lastNode;
        while ((node = el.firstChild)) {
          lastNode = frag.appendChild(node);
        }
        this.range.insertNode(frag);
        // let text = document.getElementsByClassName('ql-editor')[0].innerHTML;
        // this.bulkemail_Form.patchValue({ emailtemplate: text })
        let elem = document.getElementsByClassName('ql-editor')[0];//This is the element that you want to move the caret to the end of
        this.setEndOfContenteditable(elem);
      } else if (this.InputtoEdit == 'subject') {
        var startPos = this.subject.nativeElement.selectionStart;
        this.subject.nativeElement.focus();
        this.subject.nativeElement.value = this.subject.nativeElement.value.substr(0, this.subject.nativeElement.selectionStart) + '{{' + this.checboxvalue + '}}' +
          this.subject.nativeElement.value.substr(this.subject.nativeElement.selectionStart, this.subject.nativeElement.value.length);
        this.subject.nativeElement.selectionStart = startPos;
        this.bulkemail_Form.patchValue({ subject: this.subject.nativeElement.value })
      }
    }
    this.checboxvalue = ''
    this.placeid = false
  }

  setEndOfContenteditable(contentEditableElement) {
    var range, selection;
    if (document.createRange)//Firefox, Chrome, Opera, Safari, IE 9+
    {
      range = document.createRange();//Create a range (a range is a like the selection but invisible)
      range.selectNodeContents(contentEditableElement);//Select the entire contents of the element with the range
      range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
      selection = window.getSelection();//get the selection object (allows you to change selection)
      selection.removeAllRanges();//remove any selections already made
      selection.addRange(range);//make the range you have just created the visible selection
    }
  }


  getCursorPosition(type) {
    this.InputtoEdit = type
    this.sel = window.getSelection();
    if (this.sel.getRangeAt && this.sel.rangeCount) {
      this.range = this.sel.getRangeAt(0);
      this.placeid = true
    }
  }

  uploadFile(event) {
    let resumeFile = event.target.files[0]
    this.incorrectdoc = false
    let requiredextncv = ['doc', 'docx', 'pdf', 'txt']
    var extension = resumeFile.name.split('.')[1];
    var format = /[!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?]/;
    var includeextn = requiredextncv.includes(extension.toLowerCase())
    if (!includeextn) {
      this.incorrectdoc = true
    }
    if (resumeFile.size > 5242880) {
      this.filesizeExceeded = true
    } else {
      this.filesizeExceeded = false
    }
    if (format.test(resumeFile.name.split(".")[0])) {
      this.special_char_error = true
    } else {
      this.special_char_error = false
      if (resumeFile && this.incorrectdoc == false && this.filesizeExceeded == false) {
        this.emailsettings.uploadDocument(resumeFile).subscribe((data: any) => {
          if (data.status === 'success') {
            GlobalService.toBase64(resumeFile).then(file => {
              this.uploadedFiles.push({ filename: resumeFile.name, fileurl: data.url, file: file });
              this.bulkemail_Form.patchValue({ fileurl: _.pluck(this.uploadedFiles, 'fileurl'), filename: _.pluck(this.uploadedFiles, 'filename'), file: _.pluck(this.uploadedFiles, 'file') });
            }).catch(err => {
              this.uploadedFiles.push({ filename: resumeFile.name, fileurl: data.url, file: "" });
              this.bulkemail_Form.patchValue({ fileurl: _.pluck(this.uploadedFiles, 'fileurl'), filename: _.pluck(this.uploadedFiles, 'filename'), file: _.pluck(this.uploadedFiles, 'file') });
            });
          }
        })
      }
    }
  }

  replaceAll(str, term, replacement) {
    return str.replace(new RegExp(escapeRegExp(term), 'g'), replacement);
  }

  removeFile(doc) {
    this.uploadedFiles = _.without(this.uploadedFiles, doc);
    this.bulkemail_Form.patchValue({ fileurl: _.pluck(this.uploadedFiles, 'fileurl'), filename: _.pluck(this.uploadedFiles, 'filename'), file: _.pluck(this.uploadedFiles, 'file') });
  }


  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  SaveTalent() {
    if (this.talentvalue != null) {
      let data = {
        "candidatenumber": this.candidatenumber,
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "pipelinestatus": this.talentvalue,
        "activitylog": [
          {
            "action": "'update'",
            "tablename": "'candidate'",
            "type": "'pipeline status'",
            "updatedfieldname": "'pipelinestatus'",
            "oldvalue": "'" + this.pipelinestatus + "'",
            "newvalue": "'" + this.talentvalue + "'"
          }
        ]
      }
      this._candidateservice.updatepipelineStatus(data).subscribe((res: any) => {
        if (res.status == "success") {
          this.modalService.dismissAll();
          this._candidateservice.createCandidateData();
          this.passEntry.emit('emailsend')
        }
        else {
          this.modalService.dismissAll();
          this.passEntry.emit('error')

        }
      })
    }
    else {
      this.talentErrorMessage = 'Please Select Talent Status'
    }
  }

  cleverTapEvent(eventName, data) {
    clevertap.event.push(eventName,data);
  }


  connectoGmail() {
    let data = {
      "redirectionurl": `${frontendurl}/email_redirection?integrate=gmail`
    }
    this.emailintegrationservice.gmailintegrationurl(data).subscribe((res: any) => {
      if (res.status == 'success') {
        var winObj = window.open(res.url, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        var loop = setInterval(function() {   
          if(winObj.closed) {  
            if(!localStorage.getItem('gmail_integration_completed')){
              clevertap.event.push('IntegrationAttempt_Gmail');  
            }
              clearInterval(loop);  
          }  
      }, 1000); 
      } else {
        this.errorMessage = res.message;
        setTimeout(() => this.errorMessage = '', 5000);
      }
    })
  }

  connectoOutlook() {
    let data = {
      "redirectionurl": `${frontendurl}/email_redirection`
    }
    this.emailintegrationservice.outlookintegrationurl(data).subscribe((res: any) => {
      if (res.status == 'success') {
       var winObj =  window.open(res.url, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        var loop = setInterval(function() {   
          if(winObj.closed) {  
            if(!localStorage.getItem('outlook_integration_completed')){
              clevertap.event.push('IntegrationAttempt_Outlook');
            }
              clearInterval(loop);  
          }  
      }, 1000); 
      } else {
        this.errorMessage = res.message;
        setTimeout(() => this.errorMessage = '', 5000);
      }
    })
  }

  viewMore(i, type) {
    if (type == 'contact') {
      document.getElementById(`contact${i}`).classList.remove('d-none')
      document.getElementById(`contact_viewmore${i}`).classList.add('d-none')
    }
  }

  viewLess(i, type) {
    if (type == 'contact') {
      document.getElementById(`contact${i}`).classList.add('d-none')
      document.getElementById(`contact_viewmore${i}`).classList.remove('d-none')
    }
  }

  getSocialProfileIcon(platformName) {
    platformName = platformName ? platformName.toLowerCase() : '';
    let iconToBeShown, platformNameToBeDisplayed;
    switch (true) {
      case (platformName.includes('linkedin')):
        iconToBeShown = 'fab fa-linkedin-square';
        platformNameToBeDisplayed = 'LinkedIn';
        break;
      case (platformName.includes('angel')):
        iconToBeShown = 'fab fa-angellist';
        platformNameToBeDisplayed = 'AngelList';
        break;
      case (platformName.includes('facebook')):
        iconToBeShown = 'fab fa-facebook';
        platformNameToBeDisplayed = 'Facebook';
        break;
      case (platformName.includes('behance')):
        iconToBeShown = 'fab fa-behance';
        platformNameToBeDisplayed = 'Behance';
        break;
      case (platformName.includes('twitter')):
        iconToBeShown = 'fab fa-twitter-square';
        platformNameToBeDisplayed = 'Twitter';
        break;
      case (platformName.includes('github')):
        iconToBeShown = 'fab fa-github';
        platformNameToBeDisplayed = 'GitHub';
        break;
      case (platformName.includes('instagram')):
        iconToBeShown = 'fab fa-instagram';
        platformNameToBeDisplayed = 'Instagram';
        break;
      case (platformName.includes('google')):
        iconToBeShown = 'fab fa-google';
        platformNameToBeDisplayed = 'Google';
        break;
      case (platformName.includes('dribbble')):
        iconToBeShown = 'fab fa-dribbble';
        platformNameToBeDisplayed = 'Dribbble';
        break;
      case (platformName.includes('youtube')):
        iconToBeShown = 'fab fa-youtube';
        platformNameToBeDisplayed = 'Youtube';
        break;
      case (platformName.includes('flickr')):
        iconToBeShown = 'fab fa-flickr';
        platformNameToBeDisplayed = 'Flickr';
        break;
      case (platformName.includes('foursquare')):
        iconToBeShown = 'fab fa-foursquare';
        platformNameToBeDisplayed = 'Foursquare';
        break;
      case (platformName.includes('gitlab')):
        iconToBeShown = 'fab fa-gitlab';
        platformNameToBeDisplayed = 'GitLab';
        break;
      case (platformName.includes('meetup')):
        iconToBeShown = 'fab fa-meetup';
        platformNameToBeDisplayed = 'Meetup';
        break;
      case (platformName.includes('pinterest')):
        iconToBeShown = 'fab fa-pinterest';
        platformNameToBeDisplayed = 'Pinterest';
        break;
      case (platformName.includes('quora')):
        iconToBeShown = 'fab fa-quora';
        platformNameToBeDisplayed = 'Quora';
        break;
      case (platformName.includes('soundcloud')):
        iconToBeShown = 'fab fa-soundcloud';
        platformNameToBeDisplayed = 'SoundCloud';
        break;
      case (platformName.includes('stack overflow') || platformName.includes('stackoverflow')):
        iconToBeShown = 'fab fa-stack-overflow';
        platformNameToBeDisplayed = 'Stack Overflow';
        break;
      case (platformName.includes('vimeo')):
        iconToBeShown = 'fab fa-vimeo';
        platformNameToBeDisplayed = 'Vimeo';
        break;
      case (platformName.includes('wordpress')):
        iconToBeShown = 'fab fa-wordpress';
        platformNameToBeDisplayed = 'Wordpress';
        break;
      case (platformName.includes('xing')):
        iconToBeShown = 'fab fa-xing';
        platformNameToBeDisplayed = 'Xing';
        break;
      default:
        iconToBeShown = 'fas fa-globe';
        platformNameToBeDisplayed = 'Other';
        break;
    }
    let data = {
      iconToBeShown: iconToBeShown,
      platformNameToBeDisplayed: platformNameToBeDisplayed
    }
    return data;
  }

  copyDATA(value ,id){
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = value;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  }

  redirecToSentBox(){
    if(this.selectedPlatform == 'gmail'){
      window.open('https://mail.google.com/mail/u/0/#sent', "_blank");
    }else{
      window.open('https://outlook.live.com/mail/0/sentitems', "_blank");
    }
  }
}
